import { Pressable, View } from 'react-native'

interface ToggleSwitchProps {
  value: boolean
  disabled?: boolean
  onValueChange: (value: boolean) => void
  accessibilityLabel: string
}

export function ToggleSwitch({ value, disabled, onValueChange, accessibilityLabel }: ToggleSwitchProps) {
  return (
    <Pressable
      onPress={() => onValueChange(!value)}
      disabled={disabled}
      accessibilityRole="switch"
      accessibilityState={{ checked: value, disabled }}
      accessibilityLabel={accessibilityLabel}
      className={`h-6 w-11 flex-row items-center rounded-full px-0.5 ${disabled ? 'opacity-50' : ''} ${value ? 'justify-end bg-accent' : 'justify-start bg-border'}`}
    >
      <View className="h-5 w-5 rounded-full bg-white" />
    </Pressable>
  )
}